import * as React from "react";
export var IconBuilding = function (_a) {
    var level = _a.level, buildingName = _a.buildingName, context = _a.context;
    var classNameBuilding = "sprite-buildings-ui buildings-ui-" + buildingName + "_" + level + " icon-building__" + context;
    return React.createElement("div", { className: classNameBuilding });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/icon-building/IconBuilding.tsx
// module id = 229
// module chunks = 3